<div class="fc-ag-double-list">
    <div class="fc-ag-double-list-content-wrapper">
        <div class="available-list">
            <div class="header">{{leftHeader}}</div>
            <div class="list-wrapper">
                <div *ngFor="let item of availableItemList" class="label"
                     [ngClass]="item.isSelected ? 'selected' : ''"
                     (click)="toggleSelected(item)">{{item.label}}</div>
            </div>
        </div>
        <div class="buttons-wrapper">
            <button (click)="addItems()" class="add" id="add-items-button">
                <span class="right-arrow-btn"></span>
            </button>
            <button (click)="removeItems()" class="remove"  id="remove-items-button">
                <span class="left-arrow-btn"></span>
            </button>
        </div>
        <div class="selected-list">
            <div class="header">{{rightHeader}}</div>
            <div class="list-wrapper">
                <div *ngFor="let item of selectedItemList" class="label"
                     [ngClass]="item.isSelected ? 'selected' : ''"
                     (click)="toggleSelected(item)">{{item.label}}</div>
            </div>
        </div>
    </div>
</div>
